var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "container-content"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('a', {
    staticClass: "header-back-link",
    attrs: {
      "title": _vm.$t('common.back')
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'cabinet'
        });
      }
    }
  }), _c('div', {
    staticClass: "header-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('transfer.check')) + " "), _c('span', [_vm._v(_vm._s(_vm.transactionId))])])]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "transfer-receipt"
  }, [_vm.isOffline ? _c('div', {
    staticClass: "transfer-receipt-offline"
  }, [_c('receipt-self-employed', {
    attrs: {
      "receipt": _vm.receipt,
      "qr-code": _vm.qrCode
    }
  })], 1) : _c('div', {
    staticClass: "transfer-receipt-image"
  }, [_c('img', {
    attrs: {
      "src": "".concat(_vm.receiptLink, "?").concat(new Date()),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "transfer-receipt-copy",
    on: {
      "click": _vm.copyReceiptLink
    }
  }, [_c('div', {
    staticClass: "transfer-receipt-copy-label"
  }, [_vm._v(_vm._s(_vm.$t('check.link')))]), _c('div', {
    staticClass: "transfer-receipt-copy-link"
  }, [_vm._v(_vm._s(_vm.receiptLink))]), _c('div', {
    staticClass: "transfer-receipt-copy-icon"
  })])]), _c('div', {
    staticClass: "button-send"
  }, [_c('button', {
    on: {
      "click": _vm.onShownSharingDialog
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('to.share')) + " ")])]), _vm.isShownAnnulledButton ? _c('div', {
    staticClass: "button-link-container"
  }, [_c('div', {
    staticClass: "button-link",
    on: {
      "click": _vm.handleAnnulledDeclarationShown
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.annul')) + " ")])]) : _vm._e()])]), _c('annulled-declaration-modal', {
    attrs: {
      "transaction-id": _vm.transactionId,
      "receipt-cancel-reasons": _vm.receiptCancelReasonsList
    },
    on: {
      "receipt-cancel": _vm.handleReceiptCancelByCode
    },
    model: {
      value: _vm.isAnnulledDeclarationShown,
      callback: function callback($$v) {
        _vm.isAnnulledDeclarationShown = $$v;
      },
      expression: "isAnnulledDeclarationShown"
    }
  }), _c('cs-dialog', {
    model: {
      value: _vm.isShownReceiptSharing,
      callback: function callback($$v) {
        _vm.isShownReceiptSharing = $$v;
      },
      expression: "isShownReceiptSharing"
    }
  }, [_c('dialog-default-layout', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('share.on.social.media')))]), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "social-share-conatiner"
  }, [_c('socials-share', {
    attrs: {
      "url": _vm.receiptLink,
      "title": "".concat(_vm.$t('your.check'), " | capusta.space"),
      "description": _vm.PROJECT_INFO.description
    }
  })], 1)])])], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }